import { useParams } from "react-router-dom";
import PersonalInfoView from "../../components/UsedComp/PersonalInfoView";
import ExamResults from "./ExamResults";
import HealthInfomationView from "./HealthInfomationView";
import { getAge } from "../../utils/age";
import Loading from "../Loading";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Modal from "../../components/Modals/Modal";
import PersonalInfo from "../../components/UsedComp/PersonalInfo";
import HealthInfomation from "./HealthInfomation";
import MedicalRecord from "./MedicalRecord";
import { LaboratoryTable } from "../../components/Tables";
import toast from "react-hot-toast";
import { Button } from "../../components/Form";
import { FaBookMedical } from "react-icons/fa";
import {
  deleteEstudio,
  getAllEstudiosByPatient,
  getEstudiosByPatientId,
} from "../../redux/features/estudiosSlice";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import OrdenPdf from "../../pdf/OrdenPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { usePatient } from "../../customHooks/queries/usePatient";
import { useAntecedent } from "../../customHooks/queries/useAntecedent";
import { getAllVisitas } from "../../redux/features/visitasSlice";
import NewMedicalRecode from "./NewMedicalRecode";
import { doctorsData } from "../../components/Datas";
import StadisticsResults from "./StadisticsResult";
import { specificConfigurationDataUrl } from "../../redux/apiUrl";
import Vacunas from "./Vacunas";
import { BsEye, BsFillClipboardFill, BsFillBandaidFill } from "react-icons/bs";
import Documentos from "./Documentos";
import { logger } from "../../services/logger";

const PatientView360 = ({ setActiveTab }) => {
  const [openPatientInfo, setOpenPatientInfo] = useState(false);
  const [openPatientHealt, setOpenPatientHealt] = useState(false);
  const [openPatientCitas, setOpenPatientCitas] = useState(false);
  const [openPatientHistory, setOpenPatientHistory] = useState(false);
  const [isOpenModalCorporal, setIsOpenModalCorporal] = useState(false);
  const [openPatientVacunas, setOpenPatientVacunas] = useState(false);
  const [openPatientFiles, setOpenPatientFiles] = useState(false);
  const [doctorData, setDoctorData] = useState(null);
  const citas = useSelector(getAllVisitas);
  const [datas, setDatas] = useState({});

  const { id } = useParams();
  const dispatch = useDispatch();

  const { data: patient, isLoading: isLoadingPatient } = usePatient(id);
  const { data: antecedent, isLoading: isLoadingAntecedent } =
    useAntecedent(id);
  const isLoading = isLoadingPatient || isLoadingAntecedent;

  const estudios = useSelector(getAllEstudiosByPatient);

  useEffect(() => {
    logger.info("Página de patient360 cargada", {
      component: "PatientView360",
      additionalData: {
        path: window.location.pathname,
      },
    });
  }, []);

  // // console.log(patient.data)

  const handleBody = () => {
    const citas_sin_re = citas?.filter(
      (cita) => cita.cita.tipo_evento !== "Re Consulta"
    );
    setDatas(citas_sin_re[0]);
    setIsOpenModalCorporal(true);
  };

  useEffect(() => {
    const fetchDoctorData = async () => {
      try {
        const response = await fetch(specificConfigurationDataUrl);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del doctor");
        }
        const data = await response.json();
        setDoctorData(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctorData();
  }, []);

  useEffect(() => {
    dispatch(getEstudiosByPatientId(id));
  }, [id, dispatch]);

  if (isLoading) {
    return <Loading />;
  }
  const lastVisita = citas && citas.length > 0 ? citas[citas.length - 1] : null;

  const calculateAgeInMonths = (birthDate, visitDate) => {
    if (!birthDate || !visitDate) return 0;

    const birth = new Date(birthDate);
    const visit = new Date(visitDate);

    if (isNaN(birth.getTime()) || isNaN(visit.getTime())) return 0;

    const months = (visit.getFullYear() - birth.getFullYear()) * 12;
    const monthDiff = visit.getMonth() - birth.getMonth();
    return months + monthDiff;
  };

  const formatAge = (months) => {
    if (months >= 24) {
      const years = Math.floor(months / 12);
      return `${years} años`;
    }
    return `${months} meses`;
  };

  const patientStatsData =
    citas
      ?.map((cita) => {
        const ageInMonths = calculateAgeInMonths(
          patient.data?.persona?.fecha_nacimiento,
          cita?.cita?.fecha
        );

        const peso = cita.peso ? parseFloat(cita.peso) : null;

        let altura = cita.altura ? parseFloat(cita.altura) : null;
        if (altura && altura > 3) {
          // Si la altura parece estar en cm, convertir a metros
          altura = altura / 100;
        }

        const bmi =
          peso && altura && altura > 0
            ? parseFloat((peso / (altura * altura)).toFixed(2))
            : null;

        return {
          fecha: cita?.cita?.fecha,
          age: ageInMonths,
          altura: altura ? parseFloat((altura * 100).toFixed(1)) : null, // Se mantiene altura en cm si así lo usas en gráficas
          peso,
          circunferencia: cita.masa_craneal
            ? parseFloat(cita.masa_craneal)
            : null,
          bmi,
        };
      })
      .filter((cita) => cita.age > 0)
      .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
      .reverse() || [];

  return (
    <>
      {!patient.data ? (
        <Loading />
      ) : (
        <div className="w-full h-[calc(100vh-8rem)] overflow-clip">
          {/* Modales */}
          {openPatientInfo && (
            <Modal
              isOpen={openPatientInfo}
              closeModal={() => setOpenPatientInfo(false)}
              title="Informacion del Paciente"
              width={"max-w-3xl"}
            >
              <PersonalInfo titles={false} operation="edit" />
            </Modal>
          )}

          {openPatientHealt && (
            <Modal
              isOpen={openPatientHealt}
              closeModal={() => {
                setOpenPatientHealt(false);
                dispatch(getEstudiosByPatientId(id));
              }}
              title="Antecedentes Clinicos"
              width={"max-w-3xl"}
            >
              <HealthInfomation />
            </Modal>
          )}

          {openPatientCitas && (
            <Modal
              isOpen={openPatientCitas}
              closeModal={() => setOpenPatientCitas(false)}
              title="Análisis y Laboratorios"
              width={"max-w-3xl"}
            >
              <LaboratoryTable
                id={id}
                data={estudios}
                functions={{
                  delete: (body) => {
                    ConfirmationAlert({
                      title: "Eliminar Orden",
                      text: "Esta seguro de eliminar la orden?",
                      onAccept: async () => {
                        const res = await dispatch(deleteEstudio(body));
                        if (res?.error) {
                          toast.error(
                            "No se pudo eliminar la orden, " + res.error
                          );
                        } else {
                          dispatch(getEstudiosByPatientId(id));
                          toast.success("Orden eliminada correctamente!");
                        }
                      },
                    });
                  },
                  printPdf: async (body) => {
                    const blob = await pdf(
                      <OrdenPdf
                        data={{
                          nombre: `${body?.cita?.patient?.persona?.nombre} ${body?.cita?.patient?.persona?.apellidos}`,
                          edad: `${
                            body?.cita?.patient?.persona?.fecha_nacimiento
                              ? getAge(
                                  new Date(
                                    body?.cita?.patient?.persona?.fecha_nacimiento
                                  )
                                ) + " años"
                              : ""
                          }`,
                          fecha: new Date().toLocaleDateString("en-GB"),
                          lugarAtencion: body?.cita?.visita?.lugar_atencion,
                          seguro: `${body?.cita?.patient?.empresa_seg ?? ""}`,
                          peso: body?.cita?.visita?.peso,
                          altura: body?.cita?.visita?.altura,
                          orden: body,
                          doctor: doctorData,
                        }}
                      />
                    ).toBlob();
                    saveAs(
                      blob,
                      `Orden-${
                        body?.visita?.id
                      }-${new Date().toLocaleDateString("en-GB")}.pdf`
                    );
                  },
                }}
                button={true}
              />
            </Modal>
          )}

          {openPatientHistory && (
            <Modal
              isOpen={openPatientHistory}
              closeModal={() => setOpenPatientHistory(false)}
              title="Historial Medico"
              width={"max-w-3xl"}
            >
              <MedicalRecord />
            </Modal>
          )}

          {isOpenModalCorporal && (
            <Modal
              closeModal={() => {
                setIsOpenModalCorporal(false);
                setDatas({});
                dispatch(getEstudiosByPatientId(id));
              }}
              isOpen={isOpenModalCorporal}
              title="Examen"
            >
              <NewMedicalRecode
                cita={{
                  patient: citas?.find(
                    (cita) => cita.cita_id === datas?.cita?.id
                  )?.patient,
                  ...datas?.cita,
                }}
                currentVisita={datas}
                defaultTab={3}
              />
            </Modal>
          )}

          {openPatientVacunas && (
            <Modal
              isOpen={openPatientVacunas}
              closeModal={() => setOpenPatientVacunas(false)}
              title="Calendario de Vacunación del Paciente"
              width={"max-w-4xl"}
            >
              <Vacunas />
            </Modal>
          )}

          {openPatientFiles && (
            <Modal
              isOpen={openPatientFiles}
              closeModal={() => setOpenPatientFiles(false)}
              title="Historial de Documentos"
              width={"max-w-4xl"}
            >
              <Documentos data={patient.data} />
            </Modal>
          )}

          {/* Contenido principal */}
          <div className="sm:grid sm:grid-cols-12 sm:grid-rows-3 gap-1 overflow-auto sm:overflow-hidden h-full w-full">
            {/* Perfil del paciente */}
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="100"
              data-aos-offset="200"
              className="flex justify-center col-span-12 sm:col-span-3 row-span-3 sm:row-span-1 bg-white rounded-xl border border-border p-6 overflow-hidden"
            >
              <div
                data-aos="fade-right"
                data-aos-duration="1000"
                data-aos-delay="100"
                data-aos-offset="200"
                className="col-span-12 flex-colo gap-6 lg:col-span-4 bg-white lg:sticky top-28"
              >
                <img
                  src={
                    patient
                      ? patient.data.persona?.perfil
                      : "https://png.pngtree.com/png-vector/20230131/ourmid/pngtree-flat-user-profile-icon-on-isolated-background-with-permission-sign-vector-png-image_49602760.jpg"
                  }
                  alt="imagen de perfil"
                  className="w-20 h-20 rounded-full object-cover border border-dashed border-subMain"
                />
                <div className="gap-2 flex-colo">
                  <h2 className="text-xs font-semibold">{`${patient.data?.persona?.nombre} ${patient.data?.persona?.apellidos}`}</h2>
                  <a
                    href={`mailto:${patient.data?.persona?.email}`}
                    className="text-xs text-textGray"
                  >
                    {patient.data?.persona?.email}
                  </a>
                  <a
                    href={`https://wa.me/+571${patient.data?.persona?.telf1}/`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs"
                  >
                    {patient.data?.persona?.telf1}
                  </a>
                </div>
              </div>
            </div>

            {/* Información Personal */}
            <div className="sm:col-span-9 sm:row-span-1 sm:col-start-4 p-5 pb-0 flex flex-col justify-between border rounded-lg bg-white">
              <h2 className="font-semibold text-base">Informacion Personal</h2>
              <div className="h-5/6 overflow-y-scroll">
                <PersonalInfoView />
              </div>
              <p
                onClick={() => setOpenPatientInfo(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>

            {/* Antecedentes Personales */}
            <div className="border sm:col-span-4 sm:row-span-1 sm:row-start-2 flex flex-col justify-between p-5 pb-0 rounded-lg overflow-hidden bg-white">
              <h2 className="pb-2 font-semibold text-base">
                Antecedentes Personales
              </h2>
              <div className="h-5/6 overflow-y-scroll">
                <HealthInfomationView />
              </div>
              <p
                onClick={() => setOpenPatientHealt(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>

            {/* Estadísticas */}
            <div className="sm:col-span-2 sm:row-span-1 sm:col-start-5 p-5 pb-0 flex flex-col justify-between border rounded-lg bg-white">
              <h2 className="pb-2 font-semibold text-base">
                Gráficas pediatria
              </h2>
              <div className="h-5/6 overflow-y-scroll">
                <StadisticsResults
                  options_datas={{
                    citas: patientStatsData,
                    gender: patient.data?.persona?.sexo,
                    name: `${patient.data?.persona?.nombre} ${patient.data?.persona?.apellidos}`,
                  }}
                />
              </div>
            </div>

            {/* Historial (sección mejorada) */}
            <div className="sm:col-span-2 sm:row-span-1 sm:col-start-7 p-5 pt-4 pb-0 flex flex-col justify-between border rounded-lg bg-white">
              <div className="h-5/6 overflow-y-scroll flex flex-col justify-center">
                <div className="grid grid-cols-1 gap-2">
                  {/* VACUNAS */}
                  <div className="grid grid-cols-5 items-center min-h-[30px]">
                    <div className="col-span-3 flex items-center">
                      <p className="text-sm leading-none">Vacunas</p>
                    </div>
                    <div className="col-span-2 flex justify-end items-center">
                      <button
                        onClick={() => setOpenPatientVacunas(true)}
                        className="hover:bg-yellow-400 hover:text-white text-yellow-400 p-[2px] rounded-md flex items-center justify-center text-md"
                        style={{ width: "35px", height: "22px" }}
                      >
                        <BsFillBandaidFill size={18} />
                      </button>
                    </div>
                  </div>

                  <hr className="my-1" />

                  {/* DOCUMENTOS */}
                  <div className="grid grid-cols-5 items-center min-h-[30px]">
                    <div className="col-span-3 flex items-center">
                      <p className="text-sm leading-none">Documentos</p>
                    </div>
                    <div className="col-span-2 flex justify-end items-center">
                      <button
                        onClick={() => setOpenPatientFiles(true)}
                        className="hover:bg-yellow-400 hover:text-white text-yellow-400 p-[2px] rounded-md flex items-center justify-center text-md"
                        style={{ width: "35px", height: "22px" }}
                      >
                        <BsFillClipboardFill size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Imagenología y Laboratorios */}
            <div className="sm:col-span-4 sm:row-span-1 sm:col-start-9 p-5 pb-0 flex flex-col justify-between border rounded-lg bg-white">
              <h2 className="font-semibold text-base">
                Imagenologia y Laboratorios
              </h2>
              <div className="h-2/3 overflow-y-scroll">
                <LaboratoryTable data={estudios} button={true} view={true} />
              </div>
              <p
                onClick={() => setOpenPatientCitas(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>

            {/* Historial Médico */}
            <div className="sm:col-span-12 sm:row-span-1 sm:row-start-3 flex flex-col justify-between p-5 pb-0 border rounded-lg bg-white">
              <h2 className="font-semibold text-base">Historial Medico</h2>
              <div className="pt-0 overflow-y-scroll">
                <MedicalRecord />
              </div>
              <p
                onClick={() => setOpenPatientHistory(true)}
                className="text-right text-subMain font-medium hover:font-light text-sm cursor-pointer"
              >
                Ver mas . . .
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PatientView360;
